import { render, staticRenderFns } from "./editorOther.vue?vue&type=template&id=c6c6b182&"
import script from "./editorOther.vue?vue&type=script&lang=js&"
export * from "./editorOther.vue?vue&type=script&lang=js&"
import style0 from "./editorOther.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports